import { useMemo } from 'react';

import { useDispatch } from 'react-redux';

import featureNames from '~/shared/constants/featureFlags';
import useGender from '~/shared/utils/useGender';
import useHasFeature from '~/shared/utils/useHasFeature';
import useTldLocale from '~/shared/utils/useTldLocale';
import {
  useCustomer,
  useMembership,
  useCustomerDetails,
} from '~/techstyle-shared/react-accounts';
import { useRegion } from '~/techstyle-shared/react-intl';
import { useMarketingDisposition } from '~/techstyle-shared/react-marketing';
import { useDomain } from '~/techstyle-shared/redux-core';

export function useProductGridDefaultParameters() {
  const disposition = useMarketingDisposition();
  const customer = useCustomer();
  const membership = useMembership();
  const region = useRegion();
  const tldLocale = useTldLocale();
  const [gender, shippingZip, utmTerm] = useCustomerDetails([
    'gender',
    'shipping_zip',
    'utm_term',
  ]);
  const customerDetails = useMemo(
    () => ({
      gender,
      shippingZip,
      utmTerm,
    }),
    [gender, shippingZip, utmTerm]
  );
  const { tld } = useDomain();

  const { enabled: displayRetailPrice } = useHasFeature(
    featureNames.RETAILPRICETEST
  );
  const { genderFilterString } = useGender();
  const dispatch = useDispatch();

  const parameters = useMemo(
    () => ({
      customer,
      displayRetailPrice,
      gender,
      genderFilterString,
      membership,
      region,
      tldLocale,
      tld,
      dispatch,
      customerDetails,
      disposition,
    }),
    [
      customer,
      displayRetailPrice,
      gender,
      genderFilterString,
      membership,
      region,
      tldLocale,
      tld,
      dispatch,
      customerDetails,
      disposition,
    ]
  );

  return parameters;
}
